import '../sass/global.sass';
import '../js/vendor/jquery.inview.js';
import $ from 'jquery';

$('.video__visual-holder').click(function(e) {

  if ($(this).hasClass('is-playing')) {
    $(this).removeClass('is-playing');
    $(this).find('.video__visual')[0].pause();
  } else {
    $(this).addClass('is-playing');
    $(this).find('.video__visual')[0].play();
  }

  e.preventDefault();

});

$('.fade-in').on('inview', function(event, isInView) {
  if (isInView) {
    $(this).addClass('in-view');
  }
});